import { TooltipLinkProps } from "../../types/service";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const TooltipLink: React.FC<TooltipLinkProps> = ({
  Id,
  children,
  title,
  styleName,
  placement = "auto",
  className,
}) => (
  <OverlayTrigger
    overlay={
      <Tooltip
        id={Id}
        className={`custom-tooltip show ${className || ""}`} // <-- fix here
        style={{
          zIndex: styleName === "none" ? 9999999999999 : styleName,
        }}
        placement={placement}
        show
      >
        {title}
      </Tooltip>
    }
    placement={placement}
  >
    <span>{children}</span>
  </OverlayTrigger>
);
